<script setup lang="ts">
defineProps({
  productQuantity: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits([
  'updateProductQuantity',
  'addToCart',
  'setIncreaseProduct',
  'setDecreaseProduct',
])

const { isMobileOrTablet } = useDevice()

onMounted(() => {
  emit('updateProductQuantity')
})

const addToCart = () => {
  emit('addToCart')
}

const setIncreaseProduct = () => {
  emit('setIncreaseProduct')
}

const setDecreaseProduct = () => {
  emit('setDecreaseProduct')
}
</script>

<template>
  <div class="product-button">
    <the-button
      v-if="!productQuantity"
      class="product-button__action"
      :size="isMobileOrTablet ? 'xs' : 'sm'"
      font="sm"
      radius="lg"
      :disabled="disabled"
      @click="addToCart"
    >
      Хочу!
    </the-button>

    <the-counter
      v-else
      class="product-button__counter"
      :value="productQuantity"
      @on-increase="setIncreaseProduct"
      @on-decrease="setDecreaseProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-button {
  &__action {
    width: 108px;

    @include media('<=tablet') {
      width: 80px;
    }
  }

  &__counter {
    @include media('<=tablet') {
      min-width: 80px !important;

      :deep(.app-button) {
        min-width: 30px !important;
        min-height: 30px !important;
      }
    }
  }
}
</style>
